// extracted by mini-css-extract-plugin
export default {"cancelNotification":"_143-Y","insideModal":"czXo8","noTopMargin":"_1dpQg","canceledIcon":"_3a1bU"};